import styled from "styled-components";
import Background from "./images/BackgroundNoAuthorized.png";
interface OwnProps {
	title: string;
}

export const NoAuthorizedContentScreen = ({ title }: OwnProps) => {
	return (
		<DivContainer className="relative flex w-full h-full justify-content-center align-items-center">
			<Mask />
			<Text>{title}</Text>
			<ContainerWithBackground imageurl={Background} />
		</DivContainer>
	);
};

interface ImageProps {
	imageurl?: string | null;
}

const DivContainer = styled.div`
	max-height: 100%;
	padding-bottom: 200px;
`;

const ContainerWithBackground = styled.div<ImageProps>`
	width: 90%;
	height: 80%;
	background-image: url(${(p) => p.imageurl});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	@media screen and (max-width: 1024px) {
		height: 200px;
	}
`;

const Mask = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background: rgba(254, 254, 254, 0.43);
	backdrop-filter: blur(50px);
	pointer-events: none;
`;

const Text = styled.p`
	width: 80%;
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #000;
	text-align: center;
	font-size: 28px;
	font-style: normal;
	font-weight: 500;
	line-height: 48px;
	letter-spacing: 2.4px;
	@media screen and (max-width: 480px) {
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 1.4px;
	}
`;
